import { useEffect } from 'react';

import { useProvider } from '@/hooks/use-provider';
import { PROVIDERS, type ProviderId } from '@/providers';
import { detectSalesforce } from '@/utils/salesforce-opencti';

const detectProvider = (): ProviderId => {
  if (detectSalesforce()) {
    return PROVIDERS.SALESFORCE;
  }
  return PROVIDERS.OMNIHIT;
};

export const useProviderInitializer = () => {
  const [provider, setProviderId] = useProvider();

  useEffect(() => {
    setProviderId(detectProvider());
  }, [setProviderId]);

  useEffect(() => {
    provider
      .initialize()
      .then(() => {
        provider.authenticate().catch((e) => {
          console.error('[useProviderInitializer] authenticate error', e);
        });
      })
      .catch((e) => {
        console.error('[useProviderInitializer] initialize error', e);
      });
  }, [provider]);
};
